// src/pages/CoachingProfilePage.js
//
// Pass 44 — client/personal COACHING profile. These fields (sport, level, goals,
// my coach) are client-specific and were previously wrongly shown inside universal
// Account Settings. They now live in the My Coaching (Personal) workspace.

import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../AuthContext';
import StudentNav from '../components/shared/StudentNav';

const C = { bg: '#FAFAF8', card: '#FFFFFF', card2: '#F5F4F0', border: 'rgba(0,0,0,0.08)', t1: '#1C1B18', t2: '#57564F', t3: '#8A8980', blue: '#2563EB', green: '#16A34A' };
const font = "'DM Sans',system-ui,sans-serif";
const inp = { width: '100%', boxSizing: 'border-box', background: '#fff', border: `1px solid ${C.border}`, borderRadius: 9, padding: '9px 12px', fontSize: 14, fontFamily: font, color: C.t1, marginBottom: 12 };

export default function CoachingProfilePage() {
  const { userData, currentUser, refreshUserData } = useAuth() || {};
  const [f, setF] = useState({
    sport: userData?.sport || 'ski', level: userData?.level || '', coachGoals: userData?.coachGoals || '',
    feedbackStyle: userData?.feedbackStyle || '', dominantSide: userData?.dominantSide || '', snowboardStance: userData?.snowboardStance || '',
  });
  const [saving, setSaving] = useState(false); const [msg, setMsg] = useState('');
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    if (!currentUser?.uid) return;
    setSaving(true); setMsg('');
    try { await updateDoc(doc(db, 'users', currentUser.uid), { ...f, updatedAt: new Date() }); if (refreshUserData) await refreshUserData(); setMsg('Coaching profile saved.'); }
    catch (e) { setMsg(`Could not save: ${e.message}`); }
    setSaving(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: font, color: C.t1 }}>
      <StudentNav activeTab="" />
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '28px 22px 80px' }}>
        <h1 style={{ fontSize: 26, fontWeight: 900, margin: '0 0 4px' }}>Coaching profile</h1>
        <p style={{ color: C.t3, fontSize: 14, margin: '0 0 20px' }}>Your sport, level and coaching preferences. This lives in your My Coaching workspace, not your universal account settings.</p>
        {msg && <div style={{ background: 'rgba(22,163,74,0.1)', border: `1px solid ${C.green}`, color: C.green, borderRadius: 8, padding: '9px 12px', marginBottom: 14, fontSize: 13 }}>{msg}</div>}

        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: '20px 22px' }}>
          <h2 style={{ fontSize: 16, fontWeight: 800, margin: '0 0 14px' }}>Sports & level</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Fld label="Primary sport"><select value={f.sport} onChange={set('sport')} style={inp}><option value="ski">Ski</option><option value="snowboard">Snowboard</option></select></Fld>
            <Fld label="Level"><input value={f.level} onChange={set('level')} placeholder="Intermediate" style={inp} /></Fld>
            <Fld label="Dominant side"><input value={f.dominantSide} onChange={set('dominantSide')} style={inp} /></Fld>
            {f.sport === 'snowboard' && <Fld label="Stance"><input value={f.snowboardStance} onChange={set('snowboardStance')} placeholder="Regular / Goofy" style={inp} /></Fld>}
          </div>
          <Fld label="Coaching goals"><textarea value={f.coachGoals} onChange={set('coachGoals')} style={{ ...inp, minHeight: 64, resize: 'vertical' }} /></Fld>
          <Fld label="Preferred feedback style"><input value={f.feedbackStyle} onChange={set('feedbackStyle')} style={inp} /></Fld>
          <button disabled={saving} onClick={save} style={{ background: C.blue, color: '#fff', border: 'none', borderRadius: 9, padding: '10px 22px', cursor: 'pointer', fontFamily: font, fontWeight: 700, fontSize: 14, opacity: saving ? 0.6 : 1 }}>{saving ? 'Saving…' : 'Save coaching profile'}</button>
        </div>

        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: '20px 22px', marginTop: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 800, margin: '0 0 8px' }}>My coach</h2>
          <p style={{ color: C.t2, fontSize: 14 }}>{userData?.assignedInstructorId ? 'You have an assigned coach. Messages and reviews appear in your Messages and Videos.' : 'No coach assigned yet. Upload a video to get matched with a coach.'}</p>
        </div>
      </div>
    </div>
  );
}

function Fld({ label, children }) { return <label style={{ display: 'block' }}><span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: 'uppercase', color: C.t3, display: 'block', marginBottom: 4 }}>{label}</span>{children}</label>; }
